



/* eslint-disable */
const pageAdherentFournisseur = document.querySelector('body.template-adherent-fournisseur');
const pageGouvernance = document.querySelector('body.template-gouvernance');
const pageValeurPrincipe = document.querySelector('body.template-valeur-principe-cooperative');

if (pageAdherentFournisseur || pageGouvernance || pageValeurPrincipe) {

  const anchorLinks = document.querySelectorAll('.__sidebar > ul > li > a');

  anchorLinks[0].classList.add('is_active')

  function resetChanges(filters) {
    filters.forEach(item => {
      if (item.classList.contains('is_active')) {
        item.classList.remove('is_active');
      }
    })
  }

  anchorLinks.forEach( filter => {
    filter.onclick = function() {
      resetChanges(anchorLinks);
      this.classList.add('is_active');
    }
  })

  if('IntersectionObserver' in window){

    const observer = new IntersectionObserver(
      function(entries) { entries.forEach(entry => {
                            if(entry.isIntersecting) {
                              anchorLinks.forEach( filter => {
                                if(filter.dataset.id === entry.target.id) {
                                  resetChanges(anchorLinks);
                                  filter.classList.add('is_active');
                                }
                              })
                            }
                          })
                        }, {threshold: 0.5});

    const targets = document.querySelectorAll('.page-section');
    targets.forEach( e => observer.observe(e))
  }
}


// WEBPACK FOOTER //
// ./scripts/fixed_sidebar.js